import { fromEvent } from "file-selector";
import { processFiles, isFileWithPath } from "./file";
export function isDragEvent(event) {
    return "dataTransfer" in event;
}
export function doesEventTargetHaveFiles(event) {
    return "files" in event.target;
}
function isTargetHTMLElement(target) {
    return "tagName" in target;
}
function doesTargetHaveFiles(target) {
    return "files" in target;
}
function isEventTargetHTMLElementInput(ev) {
    return isTargetHTMLElement(ev.target) && doesTargetHaveFiles(ev.target);
}
export function isEventWithFiles(ev) {
    if (isEventTargetHTMLElementInput(ev)) {
        return !!ev.target.files.length;
    }
    return (isDragEvent(ev) && ev.dataTransfer.types.some((t) => t === "Files" || t === "application/x-moz-file"));
}
export async function extractFilesFromEvent(ev) {
    const res = await fromEvent(ev);
    const files = res.map((f) => (isFileWithPath(f) ? f : f.getAsFile()));
    return files;
}
export async function getFilesFromEvent(ev, opts) {
    const files = await extractFilesFromEvent(ev);
    return processFiles(files, opts);
}
export function isNode(target) {
    return "childNodes" in target;
}
